import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
//prime
import { BreadCrumb } from "primereact/breadcrumb";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { Button } from "primereact/button";
//pages
import { TableOperacionalFlow } from "./TableOperacionalFlow";
//services e hooks
import { useOptionsSelect } from "../../../hooks/useOptionsSelect";
import { postReportOperationalFlow } from "../../../services/Report/postReportOperationalFlow";
//components
import Select from "../../../components/input/Select";
import Panel from "../../../components/panel/panel";
import ModelReport from "../../../components/report/ModelReport";
//utils
import { getUserName } from "../../../utils/auth";
//assets
import Excel from "../../../assets/excel";
import html2pdf from "html2pdf.js";

export function OperacionalFlow() {
  const form = useForm();
  const user = getUserName();
  const {
    formState: { errors },
  } = form;
  const [dataTable, setDataTable] = useState([]);
  const [loading, setLoading] = useState(false);
  const [completeReport, setCompleteReport] = useState(false);
  const [now, setNow] = useState("");
  const [filters, setFilters] = useState();
  const {
    enterprise,
    isLoadingEnterprises,
    selectEnterprise,
    currentAccount,
    loadingCurrentAccount,
  } = useOptionsSelect();
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);
  const [enterpriseName, setEnterpriseName] = useState("");
  const items = [
    {
      template: () => (
        <Link to={"/reports/OperacionalFlow"} className="p-breadcrumb-link">
          Fluxo Operacional
        </Link>
      ),
    },
  ];

  const home = {
    template: () => (
      <Link to={"#"} className="p-breadcrumb-link">
        <i className="fa fa-home"></i>
      </Link>
    ),
  };

  const currentYear = new Date().getFullYear();

const years = Array.from({ length: currentYear - 2015 + 1 }, (_, i) => {
  const year = currentYear - i;
  return {
    value: year.toString(), 
    label: year, 
  };
});

  const months = [
    { value: 1, label: "Janeiro" },
    { value: 2, label: "Fevereiro" },
    { value: 3, label: "Março" },
    { value: 4, label: "Abril" },
    { value: 5, label: "Maio" },
    { value: 6, label: "Junho" },
    { value: 7, label: "Julho" },
    { value: 8, label: "Agosto" },
    { value: 9, label: "Setembro" },
    { value: 10, label: "Outubro" },
    { value: 11, label: "Novembro" },
    { value: 12, label: "Dezembro" },
  ];
  const transformData = (rawData, isMonthly) => {
    const transformedData = [];
    const valueKey = isMonthly ? "months" : "days";

    Object.entries(rawData.data).forEach(([category, categoryData]) => {
      Object.entries(categoryData.values).forEach(([name, valueData]) => {
        transformedData.push({
          category,
          name,
          values: valueData[valueKey] || {},
        });
      });
    });

    return transformedData;
  };

  const onSubmit = async (data) => {
    setLoading(true);
    setSelectedYear(data.year); 
    setSelectedMonth(data.month || null); 
    const notification = toast.loading(
      "Por favor aguarde a consulta está sendo realizada..."
    );
  
    try {
      const response = await postReportOperationalFlow(data);
      
      if (response.enterprise) {
        setEnterpriseName(response.enterprise); 
      } else {
        setEnterpriseName(""); 
      }
  
      const isMonthly = !data.month; 
      const transformedData = transformData(response, isMonthly);
      setDataTable(transformedData);
      setCompleteReport(true); 
  
      toast.update(notification, {
        render: "Consulta realizada com sucesso",
        type: "success",
        theme: "colored",
        autoClose: 5000,
        isLoading: false,
      });
  
    } catch (error) {
      toast.update(notification, {
        render: "Falha ao realizar consulta!",
        type: "error",
        theme: "colored",
        autoClose: 5000,
        isLoading: false,
      });
      console.error("Erro na consulta:", error);
    } finally {
      setLoading(false);
    }
  };

  const exportToExcel = (data, sheetname = "Relatório Fluxo Operacional", isMonthly = true) => {
    if (!data || data.length === 0) {
      console.warn("Nenhum dado disponível para exportação.");
      return;
    }
  
    const headers = isMonthly
      ? Array.from({ length: 12 }, (_, i) => (i + 1).toString()) 
      : Array.from({ length: 31 }, (_, i) => (i + 1).toString()); 
  
    const categoryMap = {};
  
    data.forEach((item) => {
      const category = item.name; 
      if (!categoryMap[category]) {
        categoryMap[category] = { category: item.category, values: {} };
      }
  
      headers.forEach((col) => {
        categoryMap[category].values[col] = (categoryMap[category].values[col] || 0) + (item.values[col] || 0);
      });
    });
  
    const sortedCategories = Object.keys(categoryMap).sort((a, b) => a.length - b.length);
  
    sortedCategories.forEach((category) => {
      const parentCategory = category.split(" - ")[0].split(".").slice(0, -1).join("."); 
  
      if (parentCategory && categoryMap[parentCategory]) {
        headers.forEach((col) => {
          categoryMap[parentCategory].values[col] =
            (categoryMap[parentCategory].values[col] || 0) + (categoryMap[category].values[col] || 0);
        });
      }
    });
  
    // Criar saldo inicial acumulativo
    let saldoAcumulado = 0;
    let saldoInicial = {};
    headers.forEach((col) => {
      let totalEntrada = 0;
      let totalSaida = 0;
  
      Object.keys(categoryMap).forEach((category) => {
        const item = categoryMap[category];
        if (item.category === "Entrada") {
          totalEntrada += item.values[col] || 0;
        } else if (item.category === "Saída") {
          totalSaida += item.values[col] || 0;
        }
      });
  
      saldoAcumulado += totalEntrada - totalSaida;
      saldoInicial[col] = saldoAcumulado;
    });
  
    // Criar estrutura de dados formatada para exportação
    const formattedData = sortedCategories.map((category) => {
      let row = {
        Categoria: categoryMap[category].category,
        Nome: category,
      };
  
      headers.forEach((col) => {
        row[isMonthly ? `Mês ${col}` : `Dia ${col}`] = categoryMap[category].values[col] || 0;
      });
  
      return row;
    });
  
    // Criar a linha do cabeçalho extra com os meses ou dias
    const headerRow = {
      Categoria: "",
      Nome: "",
    };
    headers.forEach((col) => {
      headerRow[isMonthly ? `Mês ${col}` : `Dia ${col}`] = col; // Preencher com os nomes dos meses ou dias
    });
  
    // Criar a segunda linha com o saldo inicial acumulado
    const saldoInicialRow = {
      Categoria: "",
      Nome: "Saldo Inicial",
    };
    headers.forEach((col) => {
      saldoInicialRow[isMonthly ? `Mês ${col}` : `Dia ${col}`] = saldoInicial[col]; // Preencher saldo inicial acumulado
    });
  
    // Criar um novo array de dados incluindo os cabeçalhos no topo
    const finalData = [headerRow, saldoInicialRow, ...formattedData];
  
    // Criar uma nova planilha e adicionar os dados
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(finalData, { skipHeader: true });
  
    // Adicionar a planilha ao livro
    XLSX.utils.book_append_sheet(wb, ws, sheetname);
  
    // Criar e baixar o arquivo Excel
    XLSX.writeFile(wb, "relatorio_fluxo_operacional.xlsx");
  };
  
  const handlePrint = () => {
    const input = document.getElementById("table-operacional-flow");

    if (!input) {
      toast.warn("Tabela não encontrada.");
      return;
    }

    const options = {
      margin: 10,
      filename: `fluxo_operacional_${now}.pdf`,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "mm", format: "a3", orientation: "landscape" },
    };

    html2pdf()
      .from(input)
      .set(options)
      .save()
      .then(() => {
        input.classList.remove("force-light");
      })
      .catch(() => {
        input.classList.remove("force-light");
      });

    
  };


  useEffect(() => {
    const today = new Date();
    const formattedDate = today.toLocaleDateString("pt-BR", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    });
    setNow(formattedDate);
  }, []);

  return (
    <div className="row d-flex justify-content-center">
      <div className="col-md-12">
        <BreadCrumb
          model={items}
          home={home}
          style={{
            background: "transparent",
            border: "none",
            fontSize: "16px",
          }}
        />
      </div>
      <div className="col-md-12"></div>
      <>
        <Panel title="Faça o filtro de Fluxo Operacional">
          <form
            className="row d-flex mt-4"
            onSubmit={form.handleSubmit(onSubmit)}
          >
            <div className="col-md-3 mb-3 form-group">
              <Select
                name="enterprise_id"
                label={
                  isLoadingEnterprises ? "Carregando..." : "Empreendimento*"
                }
                control={form.control}
                // preValue={filter?.enterprise_id}
                disabled={isLoadingEnterprises}
                isRequired={true}
                onChange={(e) => selectEnterprise(e)}
                options={enterprise}
                errors={errors}
              />
            </div>
            <div className="col-md-3 mb-3 form-group">
              <Select
                control={form.control}
                errors={form.errors}
                label={
                  loadingCurrentAccount ? "Carregando..." : "Conta Corrente"
                }
                options={currentAccount}
                name={`current_account_id`}
              />
            </div>
            <div className="col-md-3 mb-3 form-group">
              <Select
                name="year"
                control={form.control}
                isRequired={true}
                label={"Ano de referência*"}
                options={years} s
                errors={errors}
              />
            </div>
            <div className="col-md-3 mb-3 form-group">
              <Select
                name="month"
                control={form.control}
                label={"Mês de referência"}
                options={months} 
                errors={errors}
              />
            </div>

            <div className="d-flex justify-content-end my-2">
              <div
                className={`${
                  window.innerWidth <= 992 ? "w-25" : "col-md-1"
                } text-center`}
              >
                <Button
                  type="submit"
                  icon="fa fa-search"
                  aria-label="Search"
                  loading={loading}
                  className={`rounded-3 py-2.5 w-100`}
                />
              </div>
            </div>
          </form>
        </Panel>
        {dataTable?.length > 0 && (
          <>
            <Panel mainCss="mt-4">
              <>
                {/* <hr className="my-4" /> */}
                <div className="px-2 pb-3">
                  <div className="d-flex justify-content-end">
                  <Button
  onClick={() => exportToExcel(dataTable, "Relatório Fluxo Operacional", selectedMonth === null)}
  icon={<Excel />}
  iconPos="center"
  className="my-2 mx-2 me-0 p-button-success"
  rounded
/>


                    <Button
                      onClick={() => handlePrint()}
                      icon="fa-solid fa-file-pdf"
                      iconPos="center"
                      severity="secondary"
                      className="my-2 mx-2 me-0"
                      rounded
                      // label="Exportar PDF"
                    />
                  </div>
                  <div id="table-operacional-flow">
                  <ModelReport
                    date={now}
                    madeBy={user}
                    title="RELATÓRIO FLUXO OPERACIONAL"
                    legend={
                      <>
                          {enterpriseName || "Nome não disponível"}
                      </>
                    }
                    filters={filters}
                  >
                    <TableOperacionalFlow
                      dataTable={dataTable}
                      year={selectedYear}
                      month={selectedMonth}
                    />
                  </ModelReport>
                  </div>
                </div>
              </>
            </Panel>
          </>
        )}
      </>
    </div>
  );
}
